export default "__VITE_ASSET__BPfYle4N__"